import UserLeavingModal from './UserLeavingModal';

export default UserLeavingModal;
